export const KICKSTARTER_URL =
  "https://www.kickstarter.com/projects/1522759383/when-where-and-what-to-eat";
